import WelcomeMessage from "./Welcome/WelcomeMessage";
import BoxesContainer from "../../../SMARTCITY/components/boxesContainer/BoxesContainer";
import styled from "styled-components";

const Home = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "calc(100% - 100px)",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <WelcomeWrapper>
        <WelcomeMessage />
      </WelcomeWrapper>
      <BoxesContainer />
    </div>
  );
};

export default Home;

const WelcomeWrapper = styled.div`
  display: flex;
  width: 420px;

  @media only screen and (max-width: 908px) {
    display: none;
  }
`;
